// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__3XcA6","right":"styles_right__2jpUX"};